"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { courses: null };
        GState.bind(this, [
            'tenant',
            'user'
        ]);
        this._categories = [];
        const Categories = [], collector = function (arrayList) {
                arrayList.map(({categoryId, name, description, poster, subs}) => {
                    Categories.push({
                        categoryId,
                        name,
                        description,
                        poster
                    });
                    if (!!subs && !isEmpty(subs))
                        collector(Object.values(subs));
                });
            }.bind(this);
        Object.values(this.state.tenant.categories).map(({categoryId, name, description, poster, subs}) => {
            Categories.push({
                categoryId,
                name,
                description,
                poster
            });
            if (!!subs && !isEmpty(subs))
                collector(Object.values(subs));
        });
        Categories.map(({categoryId, name}) => {
            if (this.state.user.learner.categories.includes(categoryId))
                this._categories.push({
                    categoryId,
                    name
                });
        });
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Explore/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Header_Learner_template = require("../../components/Header-Learner.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Header_Learner_tag = marko_loadTag(Header_Learner_template),
    Latest_template = require("./components/Latest.marko"),
    Latest_tag = marko_loadTag(Latest_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    List_template = require("./components/List.marko"),
    List_tag = marko_loadTag(List_template),
    Wrapper_template = require("../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        "class": "content-body"
      },
    marko_attrs1 = {
        "class": "px-1"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("75cd2d"),
    marko_node0 = marko_createElement("br", null, "18", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "px-4 py-2"
      },
    marko_attrs3 = {
        "class": "mt-0 font-weight-400 black-text"
      },
    marko_attrs4 = {
        "class": "font-medium-2 black-text"
      },
    marko_node2 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "btn btn-lg btn-primary round px-4"
      },
    marko_node3 = marko_createElement("img", {
        src: "/images/illustration/explore.jpeg",
        "class": "img-fluid w-100"
      }, "17", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      class: "pl-5 pr-3",
      scroll: true,
      renderBody: function(out) {
        Header_Learner_tag({
            intro: "Good day",
            concern: state.user.first_name + "!",
            assessment: {
                icon: "bx bxs-smile",
                subject: "How may courses have you completed so far?"
              },
            ranking: {}
          }, out, __component, "1");

        out.be("div", marko_attrs0, "2", component);

        Latest_tag({}, out, __component, "3");

        out.be("section", marko_attrs1, "4", component);

        Row_tag({
            style: "background-color: #cceae8",
            class: "m-0 d-flex align-items-center round",
            col: [
                {
                    renderBody: function(out) {
                      out.be("div", marko_attrs2, "7", component);

                      out.be("h3", marko_attrs3, "8", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Explore");
                          }
                        }, out, __component, "9");

                      out.ee();

                      out.be("p", marko_attrs4, "10", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Discover variaty of courses and programs of multiple categories here. ");
                          }
                        }, out, __component, "11");

                      out.ee();

                      out.n(marko_node2, component);

                      out.be("button", marko_attrs5, "13", component, null, 0, {
                          onclick: __component.d("click", () => window.Extensions.run('SmartSearch'), false)
                        });

                      Bx_tag({
                          type: "search",
                          class: "white-text"
                        }, out, __component, "14");

                      Locale_tag({
                          text: "Search",
                          class: "align-middle px-50"
                        }, out, __component, "15");

                      out.ee();

                      out.ee();
                    }
                  },
                {
                    ns: "col-md-4 col-12",
                    qs: "col",
                    hs: "col-md-7 col-12",
                    class: "text-right",
                    renderBody: function(out) {
                      out.n(marko_node3, component);
                    }
                  }
              ]
          }, out, __component, "5");

        out.ee();

        out.n(marko_node0, component);

        out.n(marko_node1, component);

        List_tag({
            categories: component._categories
          }, out, __component, "20");

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
